import {initSplide} from "../vendor/splide";
import siteVars from "../utils/utils";

const s = {
    barCharts: '.output_chart_js',
    singleProduct: 'body.single-product',
}

export class Product {
    constructor() {
        if (!$(s.singleProduct).length) return;
        this.eventHandlers();
        this.initChartJS();
        this.lazyLoadProductSliders();
    }

    eventHandlers() {
    }

    lazyLoadProductSliders() {
        const relatedSelector = $('[data-lazyload-product-splide-categories]');
        const partnersSelector = $('[data-lazyload-product-splide-partner]');
        console.log(siteVars.rewrite_url_related);
        if (relatedSelector.children().length === 0) {
            $.get(siteVars.rewrite_url_related,
                function (response) {
                    relatedSelector.html(response.related_products_html);
                    initSplide();
                }
            );
        }

        console.log(siteVars.rewrite_url_partner)

        if (partnersSelector.children().length === 0) {
            $.get(siteVars.rewrite_url_partner,
                function (response) {
                    partnersSelector.html(response.partner_products_html);
                    initSplide();
                }
            );
        }
    }

    initChartJS() {
        const locale = navigator.language || navigator.userLanguage;
        jQuery.getScript("https://cdn.jsdelivr.net/npm/chart.js@4.4.1/dist/chart.umd.min.js", function (data, status, jqxhr) {
            $(s.barCharts).each(function () {
                const _this = $(this);
                const type = _this.data('type');
                const currency = _this.data('currency');
                const data = JSON.parse(_this.text().trim());
                const minValue = Math.min(...data.values);
                let yMin = Math.floor(minValue * 0.90);
                let yMax = Math.max(...data.values);
                yMax = Math.floor(yMax * 1.1);

                new Chart($('#' + _this.data('canvas')), {
                    type: type,
                    data: {
                        labels: data.keys.map(date => {
                            const options = {day: '2-digit', month: 'long'};
                            const parsedDate = new Date(date);
                            if (isNaN(parsedDate)) {
                                return date; // Return the original date string if parsing fails
                            }
                            return parsedDate.toLocaleDateString(locale, options);
                        }),
                        datasets: [{
                            backgroundColor: "#F7F7FA",
                            borderColor: "#E2E8F0",
                            label: _this.data('metric-name'),
                            data: data.values,
                            fill: true,
                            borderWidth: 3,
                        }]
                    },
                    options: {
                        plugins: {
                            tooltip: {
                                enabled: true,
                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                titleFont: {
                                    size: 16,
                                    weight: 'bold',
                                    family: 'Inter',
                                    color: '#fff'
                                },
                                bodyFont: {
                                    size: 14,
                                    family: 'Inter',
                                    color: '#fff'
                                },
                                footerFont: {
                                    size: 12,
                                    family: 'Inter',
                                    color: '#fff'
                                },
                                padding: 12,
                                borderColor: '#fff',
                                borderWidth: 1,
                                cornerRadius: 4,
                                position: 'nearest',
                                callbacks: {
                                    title: function (context) {
                                        return +context[0].raw + ' ' + currency;
                                    },
                                    label: function (context) {
                                        return false;
                                    },
                                    footer: function (context) {
                                        return context[0].label;
                                    }
                                }
                            },
                            pointLabels: {
                                display: false
                            },
                            legend: false
                        },
                        scales: {
                            y: {
                                beginAtZero: false,
                                max: yMax,
                                min: yMin,
                                ticks: {
                                    callback: function (value) {
                                        return value + ' ' + currency;
                                    }
                                },
                                grid: {
                                    display: false
                                }
                            },
                            x: {
                                grid: {
                                    display: false
                                }
                            }
                        },
                        interaction: {
                            mode: 'nearest',
                            axis: 'x',
                            intersect: false
                        }
                    },
                });
            });
        });
    }
}

function formatNumber(number) {
    return new Intl.NumberFormat('en-US').format(number);
}